import React, { useState, useEffect } from 'react';

const ReferencesModal = ({ isOpen, onClose, onSave, initialReferences }) => {
  const [references, setReferences] = useState('');

  useEffect(() => {
    setReferences(initialReferences || '');
  }, [initialReferences, isOpen]);

  const handleSave = () => {
    onSave(references);
    onClose();
  };

  const handleCancel = () => {
    setReferences(initialReferences || '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '30px',
        width: '90%',
        maxWidth: '600px',
        boxShadow: 'var(--standard-box-shadow)',
        fontFamily: 'var(--font-secondary)'
      }}>
        <h3 style={{ 
          marginTop: 0, 
          marginBottom: '20px',
          color: 'var(--color2)'
        }}>
          References
        </h3>
        
        
        
        <textarea
          value={references}
          onChange={(e) => setReferences(e.target.value)}
         
          style={{
            width: '100%',
            height: '200px',
            padding: '12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            fontFamily: 'var(--font-secondary)',
            resize: 'vertical',
            boxSizing: 'border-box'
          }}
        />
        
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          marginTop: '20px'
        }}>
          <button
            onClick={handleCancel}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#666',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: 'var(--color1)',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferencesModal;
